import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CabecalhoComponent } from './cabecalho.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { SafeModule } from '../../../../../../shared/pipe/safe/safe.module';

@NgModule({
  declarations: [
      CabecalhoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule,
    SafeModule
  ],
  exports: [
    CabecalhoComponent
  ]
})

export class CabecalhoModule { }
